module.exports = __webpack_public_path__ + "img/anchor-fix.dd7c7ec3.png";